// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import FormControl from "@material-ui/core/FormControl";
import TextField from '@material-ui/core/TextField';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import FormHelperText from "@material-ui/core/FormHelperText";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { formateDateandTime } from "beaktShared/helpers/masks";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function CadastroChavePix() {
    const { t } = useTranslation();
    const classes = useStyles();
    const session = useContext(SessionContext);
    const { register, handleSubmit, setValue, errors, clearError, getValues } = useForm({ mode: "onChange" });

    useEffect(() => {
        LoadChavePIX();
    }, []);
    
    const endPoint = "chavePIX/";

    const [loadingSaveForm, setLoadingSaveForm] = React.useState(false);
    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const [possuiChavePIX, setPossuiChavePIX] = React.useState(false);
    const [detalheChavePIX, setDetalheChavePIX] = React.useState([]);
    const LoadChavePIX = () => {
        const endPointGet = endPoint + "byestabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPointGet, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            
            if (result.data[0] != null)
            {
                setPossuiChavePIX(true);
                setDetalheChavePIX(result.data[0]);
            }
        });
    }

    const onSubmit = (data, e) => {
        e.preventDefault();
        
        if ((data.accessKey === "" || data.gateway === "" || data.clientID === "")) {
            showNotification("Todos os campos devem ser preenchidos para cadastrar a Chave Pix!", 'warning');
            return;
        }

        let chavePixPost = {
            accessKey: data.accessKey,
            gateway: data.gateway,
            estabelecimentoId: session.estabelecimentoId,
            usuarioId: session.id,
            clienteID: data.clientID,
        };
        
        setLoadingSaveForm(true);
        UsePostApi(endPoint, chavePixPost).then(result => {
            if(result.status !== 200)
            {
                showNotification(result.message.message,'danger');
                setLoadingSaveForm(false);  
                return false; 
            }
            
            setValue('gateway', '');
            setValue('accessKey', '');
            setValue('clientID', '');
            showNotification(result.message, 'success');
            setLoadingSaveForm(false);
            LoadChavePIX();
            return true;    
        });
    }

    return(
        <>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                close
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="maxContent">
                    <GridContainer>
                        <GridItem xs={12}>
                            <Card>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <div className="subTitulo">
                                                <h6>{t('label.data_CSJ_pix')} </h6>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <TextField
                                                    fullWidth
                                                    label={t('label.client_id') + " *"}
                                                    error={errors.clientID ? true : false}
                                                    variant="outlined"
                                                    defaultValue=""
                                                    name="clientID"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputRef={register({ required: true })}
                                                    inputProps={{maxLength: 512}}
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.clientID && <span>{t('label.required')}</span>}
                                                </FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <TextField
                                                    fullWidth
                                                    label={t('label.access_key') + " *"}
                                                    error={errors.accessKey ? true : false}
                                                    variant="outlined"
                                                    defaultValue=""
                                                    name="accessKey"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputRef={register({ required: true })}
                                                    inputProps={{maxLength: 512}}
                                                />
                                                <FormHelperText className={classes.labelRootError}>
                                                    {errors.accessKey && <span>{t('label.required')}</span>}
                                                </FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <TextField
                                                    fullWidth
                                                    label={t('label.gateway') + " *"}
                                                    error={errors.gateway ? true : false}
                                                    variant="outlined"
                                                    defaultValue=""
                                                    name="gateway"
                                                    InputLabelProps={{ shrink: true }}
                                                    inputRef={register({ required: true })}
                                                    inputProps={{maxLength: 512}}
                                                />
                                            </FormControl>
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.gateway && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </GridItem>
                                    </GridContainer>
                                    
                                    {
                                        possuiChavePIX && (
                                        <GridContainer style={{ color: '#6c757d' }}>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <div className="subTitulo" style={{ marginBottom: '10px' }}>
                                                    <h6>Atual chave pix cadastrada</h6>
                                                </div>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <span style={{ fontSize: '12px', margin: '0' }}>{t('lead.registration_date')}:</span>
                                                <h5 style={{ fontSize: '20px', margin: '0 0 10px', fontWeight: 'bold' }}> {formateDateandTime(detalheChavePIX.dataCadastro)}</h5>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <span style={{ fontSize: '12px', margin: '0' }}>{t('label.client_id')}:</span>
                                                <h5 style={{ fontSize: '20px', margin: '0 0 10px', fontWeight: 'bold' }}> {detalheChavePIX.clienteID}</h5>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <span style={{ fontSize: '12px', margin: '0' }}>{t('label.access_key')}:</span>
                                                <h5 style={{ fontSize: '20px', margin: '0 0 10px', fontWeight: 'bold' }}> {detalheChavePIX.accessKey}</h5>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <span style={{ fontSize: '12px', margin: '0' }}>{t('label.gateway')}:</span>
                                                <h5 style={{ fontSize: '20px', margin: '0 0 10px', fontWeight: 'bold' }}> {detalheChavePIX.gateway}</h5>
                                            </GridItem>
                                        </GridContainer>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')} 
                                { loadingSaveForm && 
                                    <div> ... {t('label.loading')}</div>
                                }
                            </Button>
                        </GridItem>
                    </GridContainer>
                </div>
            </form>
        </>
    );
}